import React from 'react';
import BreadcrumbNav from '@/components/shared/BreadcrumbNav';

/**
 * Breadcrumb
 * A unified navigation component with auto-collapsing for deep hierarchies (>=4 items)
 * and dropdown caret actions for multi-channel hubs like Interactions.
 */
export function Breadcrumb({ items, className = '', style = {} }) {
    if (!items || items.length === 0) return null;

    return (
        <div style={style}>
            <BreadcrumbNav items={items} className={className} />
        </div>
    );
}

export default Breadcrumb;
